export default __webpack_public_path__ + "static/media/preload_logo.51992f1f.png";